module.exports = __webpack_public_path__ + "img/export-alt.ec3f6156.svg";